import React, { Component } from "react";
import { translate } from "react-i18next";

import { Modal } from "ia-react-ui-components";

export class ModalCancel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isVisible: this.props.isVisible
    };
  }

  modalCancel = () => {
    this.props.closeModal();
  };

  modalOk = () => {
    this.setState({ isCancelModalVisible: false }, () => {
      this.props.clearInterview();
      this.props.history.push("/");
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.isVisible !== prevProps.isVisible) {
      this.setState({ isVisible: this.props.isVisible });
    }
  }

  createModal = () => {
    const { t } = this.props;

    return (
      <React.Fragment>
        <Modal
          visible={this.state.isVisible}
          closable={false}
          title={t("common.cancelTitle")}
          onOk={this.modalOk}
          onCancel={this.modalCancel}
          okText={t("common.ok")}
          cancelText={t("common.cancel")}
        >
          {t("common.cancelMsg")}
        </Modal>
      </React.Fragment>
    );
  };

  render() {
    return this.createModal();
  }
}

export default translate("translate")(ModalCancel);
